
// // src/App.js
// import React, { useState } from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import { useAuth } from './contexts/AuthContext';

// // Import Pages
// import Login from './pages/Login';
// import EmployeeDashboard from './pages/EmployeeDashboard';

// // Import Shared Components
// import Sidebar from './components/Sidebar';
// import Header from './components/Header';
// import OnboardingTour from './components/OnboardingTour';
// import OnboardingVideoModal from './components/OnboardingVideoModal';

// // Protected Route Wrapper
// const ProtectedRoute = ({ children }) => {
//   const { user, loading } = useAuth();

//   if (loading) {
//     return (
//       <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', backgroundColor: 'var(--bg-primary)' }}>
//         <p>Verifying session security...</p>
//       </div>
//     );
//   }

//   if (!user) {
//     return <Navigate to="/login" replace />;
//   }

//   return children;
// };

// // Main Workspace layout linking Sidebar, Header and EmployeeDashboard
// const DashboardRoot = () => {
//   const [currentTab, setCurrentTab] = useState('dashboard');
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const { user } = useAuth();
//   const [showTour, setShowTour] = useState(false);
//   const [showVideoTour, setShowVideoTour] = useState(false);

//   React.useEffect(() => {
//     if (user && user.id) {
//       // Only show the automatic popups if onboarding is still in progress ('ONBOARDING')
//       const isOnboardingActive = user.onboarding_status === 'ONBOARDING' || !user.onboarding_status;
//       if (isOnboardingActive) {
//         // Welcome video tour modal should come every time they login (tracked via sessionStorage so it shows once per session/login)
//         const videoSeen = sessionStorage.getItem(`onboarding_video_seen_${user.id}`);
//         if (!videoSeen) {
//           setShowVideoTour(true);
//         } else {
//           // Interactive tour should trigger automatically only ONCE (first time when they login)
//           const tourSeen = localStorage.getItem(`onboarding_tour_seen_${user.id}`);
//           const tourAutoStarted = localStorage.getItem(`onboarding_tour_auto_started_${user.id}`);
//           if (!tourSeen && !tourAutoStarted) {
//             localStorage.setItem(`onboarding_tour_auto_started_${user.id}`, 'true');
//             setShowTour(true);
//           }
//         }
//       }
//     }
//   }, [user]);

//   const handleStartTour = () => {
//     if (user && user.id) {
//       localStorage.setItem(`onboarding_tour_auto_started_${user.id}`, 'true');
//     }
//     setShowTour(true);
//   };

//   const handleStartVideoTour = () => {
//     setShowVideoTour(true);
//   };

//   return (
//     <div className="dashboard-container" style={{ width: '100%' }}>
//       <Sidebar 
//         currentTab={currentTab} 
//         setCurrentTab={(tab) => {
//           setCurrentTab(tab);
//           setSidebarOpen(false);
//         }} 
//         isOpen={sidebarOpen} 
//         onClose={() => setSidebarOpen(false)} 
//       />
      
//       {sidebarOpen && (
//         <div 
//           onClick={() => setSidebarOpen(false)}
//           style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             width: '100vw',
//             height: '100vh',
//             backgroundColor: 'rgba(15, 23, 42, 0.4)',
//             zIndex: 90,
//             backdropFilter: 'blur(4px)',
//             WebkitBackdropFilter: 'blur(4px)',
//             animation: 'fadeIn var(--transition-fast) forwards'
//           }}
//         />
//       )}

//       <div className="main-wrapper">
//         <Header 
//           title="Employee Self-Onboarding Portal" 
//           onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} 
//         />
//         <div className="content-area">
//           <EmployeeDashboard 
//             activeTab={currentTab} 
//             setActiveTab={(tab) => {
//               setCurrentTab(tab);
//               setSidebarOpen(false);
//             }} 
//             onStartTour={handleStartTour} 
//             onStartVideoTour={handleStartVideoTour}
//           />
//         </div>
//       </div>
//       <OnboardingTour 
//         user={user} 
//         active={showTour} 
//         onClose={() => setShowTour(false)} 
//         setCurrentTab={setCurrentTab} 
//       />
//       <OnboardingVideoModal
//         user={user}
//         active={showVideoTour}
//         onClose={() => setShowVideoTour(false)}
//         onStartInteractiveTour={handleStartTour}
//       />
//     </div>
//   );
// };

// function App() {
//   const { user } = useAuth();

//   return (
//     <Router>
//       <Routes>
//         {/* Public Login Route */}
//         <Route 
//           path="/login" 
//           element={user ? <Navigate to="/dashboard" replace /> : <Login />} 
//         />

//         {/* Protected Dashboard Route */}
//         <Route 
//           path="/dashboard" 
//           element={
//             <ProtectedRoute>
//               <DashboardRoot />
//             </ProtectedRoute>
//           } 
//         />

//         {/* Fallback Redirects */}
//         <Route 
//           path="/" 
//           element={<Navigate to={user ? "/dashboard" : "/login"} replace />} 
//         />
//         <Route 
//           path="*" 
//           element={<Navigate to="/" replace />} 
//         />
//       </Routes>
//     </Router>
//   );
// }

// export default App;

























// src/App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';

// Import Pages
import Login from './pages/Login';
import EmployeeDashboard from './pages/EmployeeDashboard';

// Import Shared Components
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import OnboardingTour from './components/OnboardingTour';
import OnboardingVideoModal from './components/OnboardingVideoModal';

import Loader from './components/Loader';

// Protected Route Wrapper
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <Loader fullScreen message="Verifying session security..." />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

// Main Workspace layout linking Sidebar, Header and EmployeeDashboard
const DashboardRoot = () => {
  const [currentTab, setCurrentTab] = useState('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user } = useAuth();
  const [showTour, setShowTour] = useState(false);
  const [showVideoTour, setShowVideoTour] = useState(false);

  React.useEffect(() => {
    if (user && user.id) {
      // Only show the automatic popups if onboarding is still in progress ('ONBOARDING')
      const isOnboardingActive = user.onboarding_status === 'ONBOARDING' || !user.onboarding_status;
      if (isOnboardingActive) {
        // Welcome video tour modal should come every time they login (tracked via sessionStorage so it shows once per session/login)
        const videoSeen = sessionStorage.getItem(`onboarding_video_seen_${user.id}`);
        if (!videoSeen) {
          setShowVideoTour(true);
        } else {
          // Interactive tour should trigger automatically only ONCE (first time when they login)
          const tourSeen = localStorage.getItem(`onboarding_tour_seen_${user.id}`);
          const tourAutoStarted = localStorage.getItem(`onboarding_tour_auto_started_${user.id}`);
          if (!tourSeen && !tourAutoStarted) {
            localStorage.setItem(`onboarding_tour_auto_started_${user.id}`, 'true');
            setShowTour(true);
          }
        }
      }
    }
  }, [user]);

  const handleStartTour = () => {
    if (user && user.id) {
      localStorage.setItem(`onboarding_tour_auto_started_${user.id}`, 'true');
    }
    setShowTour(true);
  };

  const handleStartVideoTour = () => {
    setShowVideoTour(true);
  };

  return (
    <div className="dashboard-container" style={{ width: '100%' }}>
      <Sidebar
        currentTab={currentTab}
        setCurrentTab={(tab) => {
          setCurrentTab(tab);
          setSidebarOpen(false);
        }}
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      {sidebarOpen && (
        <div
          onClick={() => setSidebarOpen(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(15, 23, 42, 0.4)',
            zIndex: 90,
            backdropFilter: 'blur(4px)',
            WebkitBackdropFilter: 'blur(4px)',
            animation: 'fadeIn var(--transition-fast) forwards'
          }}
        />
      )}

      <div className="main-wrapper">
        <Header
          title="Employee Self-Onboarding Portal"
          onToggleSidebar={() => setSidebarOpen(!sidebarOpen)}
        />
        <div className="content-area">
          <EmployeeDashboard
            activeTab={currentTab}
            setActiveTab={(tab) => {
              setCurrentTab(tab);
              setSidebarOpen(false);
            }}
            onStartTour={handleStartTour}
            onStartVideoTour={handleStartVideoTour}
          />
        </div>
      </div>
      <OnboardingTour
        user={user}
        active={showTour}
        onClose={() => setShowTour(false)}
        setCurrentTab={setCurrentTab}
      />
      <OnboardingVideoModal
        user={user}
        active={showVideoTour}
        onClose={() => setShowVideoTour(false)}
        onStartInteractiveTour={handleStartTour}
      />
    </div>
  );
};

function App() {
  const { user } = useAuth();

  return (
    <Router>
      <Routes>
        {/* Public Login Route */}
        <Route
          path="/login"
          element={user ? <Navigate to="/dashboard" replace /> : <Login />}
        />

        {/* Protected Dashboard Route */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardRoot />
            </ProtectedRoute>
          }
        />

        {/* Fallback Redirects */}
        <Route
          path="/"
          element={<Navigate to={user ? "/dashboard" : "/login"} replace />}
        />
        <Route
          path="*"
          element={<Navigate to="/" replace />}
        />
      </Routes>
    </Router>
  );
}

export default App;

